<template>
  <div style="padding-bottom: 20px">
    <el-card style="margin: 30px;min-height: 800px">
      <div style="display: flex;margin-bottom: 30px">
        <el-button @click="backBtn" type="primary" size="small">返回上一页</el-button>
        <el-button @click="auditBtn" v-if="detail.examination_status === 0 || detail.examine_status === 0" type="primary" size="small" >审核</el-button>
      </div>
      <div>
        <div v-if="detail.dynamic_type === 1">
          <div v-html="detail.str"></div>
          <div v-if="detail.urlList&&detail.urlList.length" style="margin-top: 30px" >
            <el-image style="width: 100px;height: 100px;margin-right: 10px" :key="index" v-for="(item,index) in detail.urlList" :preview-src-list="detail.urlList" :src="item"></el-image>
          </div>
        </div>
        <div v-else-if="detail.dynamic_type === 2">
          <div v-html="detail.str"></div>
          <div style="display: flex;justify-content: center;margin-top: 30px">
            <video-player style="width: 80%;height: 100%;" class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions">
            </video-player>
          </div>
        </div>
        <div v-else>
          <div style="display: flex;justify-content: center;font-size: 24px">{{detail.title}}</div>
          <div style="margin-top: 30px;font-size: 18px;text-indent: 2em">{{detail.abstract}}</div>
          <div style="display: flex;justify-content: center;margin-top: 30px">
            <video-player style="width: 80%;height: 100%;" class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions">
            </video-player>
          </div>
        </div>
      </div>
    </el-card>

    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examinationStatus">
          <el-select v-model="auditRuleForm.examinationStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':1,'value':'已过审'},{'key':2,'value':'未过审'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>
  </div>
</template>

<script>
export default {
   data(){
     return{
       detail:{},
       auditDialogState:false,
       auditRuleForm:{
         examinationStatus:null
       },
       auditRules:{
         examinationStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
       },
       playerOptions: {
         //播放速度
         playbackRates: [0.5, 1.0, 1.5, 2.0],
         //如果true,浏览器准备好时开始回放。
         autoplay: false,
         // 默认情况下将会消除任何音频。
         muted: false,
         // 导致视频一结束就重新开始。
         loop: false,
         // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
         preload: 'auto',
         language: 'zh-CN',
         // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
         aspectRatio: '16:9',
         // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
         fluid: true,
         sources: [{
           //类型
           type: "video/mp4",
           //url地址
           src: ''
         }],
         //你的封面地址
         poster: '',
         //允许覆盖Video.js无法播放媒体源时显示的默认信息。
         notSupportedMessage: '此视频暂无法播放，请稍后再试',
         controlBar: {
           timeDivider: true,
           durationDisplay: true,
           remainingTimeDisplay: false,
           //全屏按钮
           fullscreenToggle: true
         }
       }
     }
   },
  created() {
     this.detail = this.$route.query.row
     if (this.detail){
       if (this.detail.dynamic_type ===1){

       }else if (this.detail.dynamic_type === 2){
         if (this.detail.dynamicImgEntitys&&this.detail.dynamicImgEntitys.length){
           this.playerOptions.sources[0].src = this.detail.dynamicImgEntitys[0].url
         }
       }else{
         if (this.detail.video_url){
           this.playerOptions.sources[0].src = this.detail.video_url
         }
       }
     }
     console.log(this.detail)
  },
  methods:{
    backBtn(){
      this.$router.back()
    },
    auditBtn(){
      this.auditDialogState = true
    },
    auditCancel(){
      this.auditDialogState = false
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.detail.dynamic_type === 1){
            console.log('动态审核')
            this.postAxios("/dynamic/examineDynamic", {
              parameterMap:{
                examinationStatus:this.auditRuleForm.examinationStatus,
                ids:[this.detail.id]
              }
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditDialogState = false
                setTimeout(()=>{
                  this.$router.back()
                },500)
              }
            })
          }else{
            console.log('视频审核')
            this.postAxios("/newsVideo/updNewsVideoExamineStatusById", {
              examineStatus:this.auditRuleForm.examinationStatus,
              ids:[this.detail.id]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditDialogState = false
                setTimeout(()=>{
                  this.$router.back()
                },500)
              }
            })
          }
          // this.postAxios("/dynamic/examineDynamic", {
          //   parameterMap:{
          //     examinationStatus:this.auditRuleForm.examinationStatus,
          //     ids:[this.auditId]
          //   }
          // }).then(res=>{
          //   if (res.success){
          //     this.$message.success(res.message)
          //     this.auditId = ''
          //     this.auditDialogState = false
          //     this.getDynamicList()
          //   }
          // })
        }
      });
    },
  }
}
</script>

<style scoped>

</style>